module.exports = __webpack_public_path__ + "static/media/ubuntu.d0553ce2.svg";